// List of admin emails allowed to access admin dashboard
export const ADMIN_EMAILS = [
    'nizaam@fourminutemedicine.com',
    'kylie@fourminutemedicine.com',
    'vela@fourminutemedicine.com'
];

// List of admin emails that receive HPCSA verification notifications
export const VERIFICATION_NOTIFICATION_EMAILS = [
    'nizaam@fourminutemedicine.com',
    'kylie@fourminutemedicine.com'
];

/**
 * Check if a user has admin access based on their email
 * @param {Object} user - The user object from auth context
 * @returns {boolean} - True if user is an admin, false otherwise
 */
export const isAdmin = (user) => {
    if (!user || !user.email) {
        return false;
    }
    return ADMIN_EMAILS.includes(user.email.toLowerCase());
};

/**
 * Get admin emails that have opted in to receive verification notifications
 * @param {Object} supabase - Supabase client instance
 * @returns {Promise<string[]>} - Array of admin emails who opted in
 */
export async function getAdminsOptedInForVerificationEmails(supabase) {
    try {
        // Query users_profiles for admin emails and their preference
        const { data: adminProfiles, error } = await supabase
            .from('users_profiles')
            .select('email, receive_verification_emails, profileid')
            .in('email', ADMIN_EMAILS.map(email => email.toLowerCase()));
        
        if (error && error.code === '42703') {
            // Column doesn't exist yet - default to no emails (opted out)
            // They can set preference via dashboard which will create the column
            console.log('receive_verification_emails column not found, defaulting to opted out');
            return [];
        } else if (error) {
            console.warn('Error fetching admin preferences, defaulting to opted out:', error);
            return [];
        }
        
        // Build a map of email -> preference
        const preferenceMap = new Map();
        (adminProfiles || []).forEach(profile => {
            const email = profile.email?.toLowerCase();
            if (email) {
                // Check column preference, default to false if not set
                const preference = profile.receive_verification_emails;
                preferenceMap.set(email, preference === true); // Only true if explicitly set to true
            }
        });
        
        // Filter ADMIN_EMAILS to only those who opted in
        // Default to false (opted out) if we don't have their preference
        const optedIn = ADMIN_EMAILS.filter(email => {
            const emailLower = email.toLowerCase();
            return preferenceMap.get(emailLower) === true; // Only include if explicitly true
        });
        
        return optedIn; // Return only those who opted in (empty array if none)
    } catch (error) {
        console.error('Error getting admin email preferences:', error);
        // Default to opted out if there's an error
        return [];
    }
}

